
import { jsPDF } from "jspdf";
import logoEvomap from '../../../assets/images/logos/logo_preta.jpeg';
import autoTable from 'jspdf-autotable';
import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Table,
  Button,
  CardFooter,
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
  Badge,
  Alert
} from "reactstrap";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { api } from "../../../config";
import EtapasProcesso from "../../../Components/Common/EtapaReserva";
import CadastroExpositor from "../../Expositores/Cadastro/index"; // Importando o componente de cadastro
import EstandeDetail from "../../../Components/Common/Estandedetalhes";
import { fetchComAuth, fetchComAuthJson } from "../../../common/api";
import CadastroEspaco from "../../Espacos/Cadastro/index";

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const ReservaDetalhes = ({gerouVenda}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [reserva, setReserva] = useState(null);
  const [tags, setTags] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalReprovar, setModalReprovar] = useState(false);
  const [modalExpositor, setModalExpositor] = useState(false); 
  const [modalCadastroEspaco, setModalCadastroEspaco] = useState(false); 
  const [modalEstande, setModalEstande] = useState(false); 
  const [loadingAprovacao, setLoadingAprovacao] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [arquivoExcluir, setArquivoExcluir] = useState(null);
  const [comerciais, setComercialFeira] = useState([]);
  const [permissaoCadastro, setPermissaoCadastro] = useState(false);

  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';

  const confirmarExclusao = (id) => {
    setArquivoExcluir(id);
    setModalDelete(true);
  };

  const fetchReserva = async (controller) => {
    try {
      setLoading(true);
      setError(null);
  
      const response = await fetchComAuth(`${api.API_URL}/reserva/${id}`, {
        method: 'GET',
        signal: controller ? controller.signal : undefined
      });
  
      const data = await response.json();
      setReserva(data.data.dados);
      
      setTags(data.data.tags);
      setLoading(false);
    } catch (err) {
      if (err.name === 'AbortError') {
        setError('Requisição demorou muito - tempo limite excedido');
      } else {
        setError(err.message || 'Falha ao carregar reserva');
      }
    }
  };
  
  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
  
    fetchReserva();
  
    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, [id]);

  useEffect(() => {
    const carregarComerciaisSalvos = async () => {
      if (!reserva) return;
  
      try {
        const response = await fetchComAuth(`${api.API_URL}/feira/comerciais/${reserva.feira_id}`, {
          method: 'GET'
        });
  
        const data = await response.json();
        setComercialFeira(data.data);
        
      } catch (err) {
        console.error("Erro ao carregar comerciais da feira", err);
      }
    };
    carregarComerciaisSalvos();
  }, [reserva]);

  useEffect(() => {
    const fetchPermissao = async () => {
      // ADICIONE ESTA LINHA: Se reserva for null, interrompe a execução
      if (!reserva) return;

      if (['JOTAPIX', 'EVOMAP'].includes(userType)) {
        setPermissaoCadastro(true);
      } else {
        try {
          const response = await fetchComAuth(`${api.API_URL}/dashboard/${reserva.feira_id}`, {
            method: 'GET'
          });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            
            const data = await response.json();
            
            if (!data) throw new Error("Dados vazios recebidos da API");
            
            setPermissaoCadastro(data.data.dados || []);
            
            if (data.data.permissao && ['COMERCIAL', 'ORGANIZACAO'].includes(userType)) {
              const acessos = data.data.permissao.filter((f) => f.chave_perfil === userType);
              const permissao = acessos.filter(a => a.dashboard_permissao.chave.includes('CADASTRO_ESPAÇOS'));
              
              setPermissaoCadastro(permissao.length > 0);
            }
            
            setError(null);
          } catch (error) {
              console.error("Erro ao buscar dados da feira:", error);
              setError(`Erro ao carregar dados: ${error.message}`);
          } finally {
            
          }
        }
        
      };

    fetchPermissao();
  }, [reserva]);
  
  const handleUpdateReserva = async () => {
    await fetchReserva();
  };

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD/MM/YYYY");
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = getHour >= 12 ? "PM" : "AM";
    return moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  };

  const handleExpositorAprovar = async () => {
    try {
      setLoadingAprovacao(true);

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/expositor`, {
        method: 'POST',
        body: JSON.stringify({
          aprovado: true,
          reserva_id: reserva.id,
          expositor_id: reserva.expositor_id
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Expositor aprovado com sucesso!");
        setReserva(prev => ({
          ...prev,
          expositor: {
            ...prev.expositor,
            aprovado: true,
            pendente: false
          }
        }));
      } else {
        toast.error("Falha ao aprovar expositor!");
      }
    } catch (err) {
      toast.error("Falha ao aprovar expositor!");
    } finally {
      setLoadingAprovacao(false);
    }
  };

  const handleExpositorReprovar = async () => {
    try {
      setLoadingAprovacao(true);
    
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/expositor`, {
        method: 'POST',
        body: JSON.stringify({
          aprovado: false,
          reserva_id: reserva.id,
          expositor_id: reserva.expositor_id
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Expositor reprovado com sucesso!");
        setReserva(prev => ({
          ...prev,
          cancelado: true,
          expositor: {
            ...prev.expositor,
            aprovado: false,
            pendente: false
          }
        }));
      } else {
        toast.error("Falha ao reprovar expositor!");
      }
    } catch (err) {
      toast.error("Falha ao reprovar expositor!");
    } finally {
      setLoadingAprovacao(false);
    }
  };
  
  const handleExcluirArquivo = async (arquivoId) => {
      try {
       
        const response = await fetchComAuth(`${api.API_URL}/reserva/excluirArquivo/${arquivoId}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          toast.success("Arquivo excluído com sucesso!");
          setModalDelete(false);
          await handleUpdateReserva();
        } else {
          throw new Error('Falha ao excluir arquivo');
        }
      } catch (err) {
        console.error('Erro ao excluir arquivo:', err);
        toast.error(err.message || "Erro ao excluir arquivo");
      }
  };

  const formatarEndereco = (reserva) => {
    const end = reserva.expositor;
    
    if (!end.endereco && !end.numero && !end.complemento && !end.bairro && 
        !end.cidade && !end.estado && !end.pais && !end.cep) {
        return <p className="fw-medium mb-1">Sem endereço</p>;
    }

    const linhaEndereco = [
        end.endereco || null,
        end.numero ? end.numero : 'Sem número',
        end.complemento || null,
        end.bairro || null
    ].filter(Boolean).join(', ');

    const linhaCidadeEstado = [
        end.cidade || null,
        end.estado || null,
        end.pais || null
    ].filter(Boolean).join(', ');


    return (
        <>
        <h6 className="mb-1">
          <span className="fw-semibold"> Endereço:</span> 
        </h6>
            {linhaEndereco && <p className="mb-1">{linhaEndereco}</p>}
            {linhaCidadeEstado && <p className="mb-1">{linhaCidadeEstado}</p>}
            {end.cep && <p className="mb-1">{end.cep}</p>}
        </>
    );
  };

  const handleEspacoSalvo = () => {
    toggleModalCadastroEspaco();
    fetchReserva(); // Recarrega os detalhes da reserva para refletir as mudanças no estande
  };

  const handleExportarTudoPDF = async () => {
    try {
      if (!reserva || !reserva.estande || !reserva.expositor) {
        toast.error("Dados da reserva incompletos para gerar o PDF.");
        return;
      }

      const doc = new jsPDF({
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const margin = 12;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const contentWidth = pageWidth - margin * 2;

      const primaryColor = [54, 54, 54];
      const secondaryColor = [90, 90, 90];
      const lightGray = [245, 245, 245];
      const borderGray = [210, 210, 210];

      const estande = reserva.estande;
      const expositor = reserva.expositor;

      const tipoDocumento = reserva.gerou_venda ? "VENDA" : "RESERVA";
      const dataGeracao = moment().format("DD/MM/YYYY HH:mm");

      const safe = (value, fallback = "Não informado") => {
        if (value === null || value === undefined || value === "") return fallback;
        return value;
      };

      const sanitizeFileName = (value) => {
        return String(value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-zA-Z0-9-_]/g, "_")
          .replace(/_+/g, "_");
      };

      const getLogoImage = async () => {
        return new Promise((resolve) => {
          try {
            const img = new Image();
            img.src = logoEvomap;
            img.crossOrigin = "Anonymous";

            img.onload = () => resolve(img);
            img.onerror = () => resolve(null);
          } catch (e) {
            resolve(null);
          }
        });
      };

      const logoImg = await getLogoImage();

      const setSectionTitle = (title, y) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(...primaryColor);
        doc.text(title, margin, y);

        doc.setDrawColor(...borderGray);
        doc.setLineWidth(0.2);
        doc.line(margin, y + 2, pageWidth - margin, y + 2);

        return y + 7;
      };

      const checkPageBreak = (currentY, neededSpace = 35) => {
        if (currentY + neededSpace > pageHeight - 25) {
          doc.addPage();
          return 18;
        }

        return currentY;
      };

      const addFooter = () => {
        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);

          doc.setDrawColor(...borderGray);
          doc.setLineWidth(0.2);
          doc.line(margin, pageHeight - 16, pageWidth - margin, pageHeight - 16);

          if (logoImg) {
            try {
              const logoWidth = 22;
              const logoHeight = 8;
              const logoX = margin;
              const logoY = pageHeight - 13;

              doc.addImage(logoImg, "JPEG", logoX, logoY, logoWidth, logoHeight);
            } catch (e) {
              // Se a logo falhar, segue sem travar o PDF.
            }
          }

          doc.setFont("helvetica", "normal");
          doc.setFontSize(7.5);
          doc.setTextColor(120, 120, 120);

          const feiraNome = reserva.feira?.nome || "Feira não informada";

          doc.text(
            `${feiraNome} • Gerado em ${dataGeracao}`,
            pageWidth / 2,
            pageHeight - 9,
            { align: "center" }
          );

          doc.text(
            `Página ${i} de ${totalPages}`,
            pageWidth - margin,
            pageHeight - 9,
            { align: "right" }
          );
        }
      };

      const calcularLinhasFinanceiras = () => {
        const linhas = [];

        const largura = estande.largura || 0;
        const comprimento = estande.comprimento || 0;
        const area = estande.area || 0;

        linhas.push([
          {
            content: `${safe(estande.nome, "Espaço")} - ${largura}m x ${comprimento}m`,
            styles: { fontStyle: "bold" },
          },
          formatCurrency(estande.valor || 0),
          `${area} m²`,
          {
            content: formatCurrency(estande.valor_total || 0),
            styles: { fontStyle: "bold" },
          },
        ]);

        const tagsRows = (estande.tags || []).map((tagEstande) => {
          const isManual = !!tagEstande.manual;

          const valorUnitario = isManual
            ? Number(tagEstande.valor_salvo || 0)
            : Number(tags?.find((t) => t.tag_id === tagEstande.id)?.valor || 0);

          const cobraPorMetro = tagEstande.tag && tagEstande.tag[0]?.cobra_por_metro;

          const quantidade =
            isManual && Number(tagEstande.quantidade_salva || 0) > 0
              ? Number(tagEstande.quantidade_salva || 0)
              : cobraPorMetro
                ? area
                : 1;

          const quantidadeLabel =
            isManual && Number(tagEstande.quantidade_salva || 0) > 0
              ? quantidade
              : cobraPorMetro
                ? `${area} m²`
                : quantidade;

          const total = isManual
            ? Number(tagEstande.quantidade_salva || 0) > 0
              ? Number(tagEstande.valor_salvo || 0) * Number(tagEstande.quantidade_salva || 0)
              : Number(tagEstande.valor_salvo || 0) * (cobraPorMetro ? area : 1)
            : valorUnitario * (cobraPorMetro ? area : 1);

          return [
            `${tagEstande.nome}${isManual ? " (Manual)" : ""}`,
            formatCurrency(valorUnitario),
            quantidadeLabel,
            {
              content: formatCurrency(total),
              styles: { fontStyle: "bold" },
            },
          ];
        });

        linhas.push(...tagsRows);

        if (estande?.kva != null || estande?.kva_manual) {
          const isManual = !!estande.kva_manual;

          const valorUnitario = isManual
            ? Number(estande.kva_valor_salvo || 0) / Number(estande.kva_quantidade_salva || 1)
            : Number(estande.kva?.valor || 0) / Number(estande.kva?.quantidade || 1);

          const quantidade = isManual
            ? Number(estande.kva_quantidade_salva || 1)
            : estande.kva?.cobra_por_metro
              ? `${area} m²`
              : Number(estande.kva?.quantidade || 1);

          const total = isManual
            ? Number(estande.kva_valor_salvo || 0)
            : estande.kva?.cobra_por_metro
              ? Number(estande.kva?.valor || 0) * area
              : Number(estande.kva?.valor || 0);

          linhas.push([
            `KVA${isManual ? " (Manual)" : ""}`,
            formatCurrency(valorUnitario),
            quantidade,
            {
              content: formatCurrency(total),
              styles: { fontStyle: "bold" },
            },
          ]);
        }

        if (estande?.estacionamento != null || estande?.estacionamento_manual) {
          const isManual = !!estande.estacionamento_manual;

          const valorTotalEstacionamento = isManual
            ? Number(estande.estacionamento_valor_salvo || 0)
            : Number(estande.estacionamento?.valor || 0);

          const quantidade = isManual
            ? Number(estande.estacionamento_quantidade_salva || 1)
            : Number(estande.estacionamento?.quantidade || 1);

          const valorUnitario =
            quantidade > 0 ? valorTotalEstacionamento / quantidade : valorTotalEstacionamento;

          linhas.push([
            `Estacionamento${isManual ? " (Manual)" : ""}`,
            formatCurrency(valorUnitario),
            quantidade,
            {
              content: formatCurrency(valorTotalEstacionamento),
              styles: { fontStyle: "bold" },
            },
          ]);
        }

        return linhas;
      };

      const calcularTotalItens = () => {
        const subtotalEstande = Number(estande.valor_total || 0);

        const totalTags = (estande.tags || []).reduce((sum, tag) => {
          const isManual = !!tag.manual;

          const valorUnitario = isManual
            ? Number(tag.valor_salvo || 0)
            : Number(tags?.find((t) => t.tag_id === tag.id)?.valor || 0);

          const cobraPorMetro = tag.tag && tag.tag[0]?.cobra_por_metro;

          const quantidade =
            isManual && Number(tag.quantidade_salva || 0) > 0
              ? Number(tag.quantidade_salva || 0)
              : cobraPorMetro
                ? Number(estande.area || 0)
                : 1;

          return sum + valorUnitario * quantidade;
        }, 0);

        const totalKva = estande.kva_manual
          ? Number(estande.kva_valor_salvo || 0)
          : estande.kva
            ? estande.kva.cobra_por_metro
              ? Number(estande.kva.valor || 0) * Number(estande.area || 0)
              : Number(estande.kva.valor || 0)
            : 0;

        const totalEstacionamento = estande.estacionamento_manual
          ? Number(estande.estacionamento_valor_salvo || 0)
          : estande.estacionamento
            ? Number(estande.estacionamento.valor || 0)
            : 0;

        return subtotalEstande + totalTags + totalKva + totalEstacionamento;
      };

      const carregarImagemUrl = async (url) => {
        return new Promise((resolve, reject) => {
          try {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = `${url}${url.includes("?") ? "&" : "?"}t=${Date.now()}`;

            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error("Erro ao carregar imagem"));

            setTimeout(() => reject(new Error("Timeout ao carregar imagem")), 7000);
          } catch (error) {
            reject(error);
          }
        });
      };

      const renderizarImagensDoEspaco = async (startY) => {
        if (!reserva.estande.imagens?.length) return startY;

        let imageY = checkPageBreak(startY, 75);
        imageY = setSectionTitle("IMAGEM DO ESPAÇO", imageY);

        const imagens = reserva.estande.imagens; 
        const gap = 5;
        const imgWidth = imagens.length > 1 ? (contentWidth / 2) - (gap / 2) : contentWidth;
        let currentX = margin;
        let maxRowHeight = 0; // Variável correta

        for (let i = 0; i < imagens.length; i++) {
          const imagem = imagens[i];

          try {
            const img = await carregarImagemUrl(imagem.url);

            // CALCULA PROPORÇÃO PARA NÃO DISTORCER
            const ratio = img.height / img.width;
            let imgHeight = imgWidth * ratio;

            const maxHeightAllowed = 70; 
            let finalWidth = imgWidth;
            let offsetX = 0;

            if (imgHeight > maxHeightAllowed) {
              imgHeight = maxHeightAllowed;
              finalWidth = imgHeight / ratio; // Recalcula largura proporcional à altura
              offsetX = (imgWidth - finalWidth) / 2; // Centraliza no slot
            }

            if (imageY + imgHeight + 12 > pageHeight - 25) {
              doc.addPage(); 
              imageY = 18; 
              currentX = margin;
            }

            doc.addImage(img, "JPEG", currentX + offsetX, imageY, finalWidth, imgHeight);

            doc.setFontSize(7);
            doc.setTextColor(120, 120, 120);
            doc.text(`Imagem ${i + 1}`, currentX, imageY + imgHeight + 4);

            maxRowHeight = Math.max(maxRowHeight, imgHeight);

          } catch (error) {
            // FIX: Agora usa maxRowHeight em vez de maxHeight
            const errorPlaceholderHeight = 35;
            
            if (imageY + errorPlaceholderHeight + 12 > pageHeight - 25) {
              doc.addPage();
              imageY = 18;
              currentX = margin;
              maxRowHeight = 0;
            }

            doc.setDrawColor(...borderGray);
            doc.rect(currentX, imageY, imgWidth, errorPlaceholderHeight);

            doc.setFontSize(7);
            doc.setTextColor(140, 140, 140);
            doc.text(`Imagem ${i + 1} não carregada`, currentX + 3, imageY + 18);

            maxRowHeight = Math.max(maxRowHeight, errorPlaceholderHeight);
          }

          // Lógica de Grade (2 colunas) - Unificada para Sucesso ou Erro
          if (imagens.length > 1 && i % 2 === 0 && i !== imagens.length - 1) {
            currentX += imgWidth + gap;
          } else {
            imageY += maxRowHeight + 12; // Pula para a próxima linha
            currentX = margin;
            maxRowHeight = 0;
          }
        }

        return imageY;
      };
      
      // =====================================================
      // CAPA / CABEÇALHO
      // =====================================================

      let y = 16;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(...primaryColor);
      doc.text(`DETALHES ${tipoDocumento} #${reserva.id}`, margin, y);
      doc.setLineWidth(0.4);
      doc.line(margin, y + 2, pageWidth - margin, y + 2);

      y += 8;

      // =====================================================
      // DADOS DO EXPOSITOR
      // =====================================================

      y = setSectionTitle("DADOS DO EXPOSITOR", y);

      const enderecoCompleto = [
        [expositor.endereco, expositor.numero].filter(Boolean).join(", "),
        expositor.complemento,
        expositor.bairro,
        [expositor.cidade, expositor.estado].filter(Boolean).join(" / "),
        expositor.pais,
        expositor.cep,
      ]
        .filter(Boolean)
        .join(" - ");

      const expositorRows = [
        ["RAZÃO SOCIAL / NOME", safe(expositor.nome)],
        ["NOME FANTASIA / NOME MAPA", safe(expositor.nome_fantasia || expositor.nome_mapa)],
        ["CNPJ / DOCUMENTO", safe(expositor.cnpj_codigo_internacional)],
        ["INSCRIÇÃO ESTADUAL", safe(expositor.inscricao_estadual)],
        ["RESPONSÁVEL", safe(expositor.responsavel)],
        ["TELEFONE", safe(expositor.telefone)],
        ["CELULAR", safe(expositor.celular)],
        ["WHATSAPP", safe(expositor.whatsapp)],
        ["FAX", safe(expositor.fax)],
        ["E-MAIL PRINCIPAL", safe(expositor.email)],
        ["E-MAIL COBRANÇA", safe(expositor.email_cobranca)],
        ["E-MAIL FINANCEIRO", safe(expositor.email_financeiro)],
        ["E-MAIL CONTRATO", safe(expositor.email_contrato)],
        ["E-MAIL MARKETING", safe(expositor.email_estande)],
        ["E-MAIL RENOVAÇÃO", safe(expositor.email_renovacao)],
        ["ENDEREÇO", safe(enderecoCompleto)],
      ];

      autoTable(doc, {
        startY: y,
        margin: { left: margin, right: margin },
        theme: "grid",
        body: expositorRows,
        styles: {
          fontSize: 7.8,
          cellPadding: 1.8,
          lineColor: borderGray,
          lineWidth: 0.1,
          overflow: "linebreak",
          valign: "top",
        },
        columnStyles: {
          0: {
            cellWidth: 55,
            fontStyle: "bold",
            fillColor: lightGray,
            textColor: primaryColor,
          },
          1: {
            cellWidth: contentWidth - 55,
            textColor: secondaryColor,
          },
        },
      });

      y = doc.lastAutoTable.finalY + 8;
      // =====================================================
      // DADOS DA RESERVA
      // =====================================================

      y = checkPageBreak(y, 32);
      y = setSectionTitle(`DADOS DA ${tipoDocumento}`, y);

      autoTable(doc, {
        startY: y,
        margin: { left: margin, right: margin },
        theme: "grid",
        body: [
          [`Código da ${tipoDocumento.toLowerCase()}`, `#${reserva.id}`],
          ["Data da solicitação", reserva.created_at ? moment(reserva.created_at).format("DD/MM/YYYY HH:mm") : "Não informado"],
        ["Responsável comercial", safe(reserva.comercial?.nome)],
          ["E-mail comercial", safe(reserva.comercial?.email)],
        ],
        styles: {
          fontSize: 8.5,
          cellPadding: 2,
          lineColor: borderGray,
          lineWidth: 0.1,
        },
        columnStyles: {
          0: {
            cellWidth: 48,
            fontStyle: "bold",
            fillColor: lightGray,
            textColor: primaryColor,
          },
          1: {
            cellWidth: contentWidth - 48,
            textColor: secondaryColor,
          },
        },
      });

      y = doc.lastAutoTable.finalY + 8;

      // =====================================================
      // DADOS DO ESTANDE
      // =====================================================

      y = checkPageBreak(y, 45);
      y = setSectionTitle("DADOS DO ESPAÇO", y);

      const dimensoes = estande.alterou_area
        ? "Área alterada manualmente"
        : `${safe(estande.largura, 0)}m x ${safe(estande.comprimento, 0)}m`;

      autoTable(doc, {
        startY: y,
        margin: { left: margin, right: margin },
        theme: "grid",
        body: [
          ["Nome do espaço", safe(estande.nome)],
          ["Pavilhão", safe(estande.pavilhao?.nome)],
          ["Área", `${safe(estande.area, 0)} m²`],
          ["Dimensões", dimensoes],
          ["Altura mínima", estande.altura_minima ? `${estande.altura_minima}m` : "Não informado"],
          ["Altura máxima", estande.altura_maxima ? `${estande.altura_maxima}m` : "Não informado"],
          ["Metragem bonificada", estande.metragem_bonificada > 0 ? `${estande.metragem_bonificada} m²` : "Não possui"],
          ["Observação do espaço", safe(estande.observacao)],
        ],
        styles: {
          fontSize: 8.5,
          cellPadding: 2,
          lineColor: borderGray,
          lineWidth: 0.1,
        },
        columnStyles: {
          0: {
            cellWidth: 48,
            fontStyle: "bold",
            fillColor: lightGray,
            textColor: primaryColor,
          },
          1: {
            cellWidth: contentWidth - 48,
            textColor: secondaryColor,
          },
        },
      });

      
      y = doc.lastAutoTable.finalY + 8;

      y = await renderizarImagensDoEspaco(y);

      // =====================================================
      // TABELA DE ITENS E VALORES
      // =====================================================

      y = checkPageBreak(y, 55);
      y = setSectionTitle("ITENS DO ESPAÇO E VALORES", y);

      const linhasFinanceiras = calcularLinhasFinanceiras();
      const totalItensCalculado = calcularTotalItens();

      autoTable(doc, {
        startY: y,
        margin: { left: margin, right: margin },
        head: [["Item", "Valor Unitário", "Quantidade", "Valor Total"]],
        body: linhasFinanceiras,
        theme: "grid",
        headStyles: {
          fillColor: primaryColor,
          textColor: 255,
          fontSize: 8.5,
          fontStyle: "bold",
          cellPadding: 2,
        },
        bodyStyles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: borderGray,
          lineWidth: 0.1,
        },
        columnStyles: {
          0: {
            cellWidth: contentWidth - 85,
          },
          1: {
            cellWidth: 30,
            halign: "right",
          },
          2: {
            cellWidth: 25,
            halign: "right",
          },
          3: {
            cellWidth: 30,
            halign: "right",
            fontStyle: "bold",
          },
        },
      });

      y = doc.lastAutoTable.finalY + 5;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(...primaryColor);
      doc.text("TOTAL DOS ITENS", pageWidth - margin - 55, y);
      doc.text(formatCurrency(totalItensCalculado), pageWidth - margin, y, { align: "right" });

      y += 10;

      // =====================================================
      // DADOS FINANCEIROS
      // =====================================================

      y = checkPageBreak(y, 50);
      y = setSectionTitle("DADOS FINANCEIROS", y);

      const valorOriginal = Number(estande.valor_total_geral || totalItensCalculado || 0);

      const valorFinal = reserva.alterado_financeiro
        ? Number(reserva.valor_total_financeiro || valorOriginal)
        : valorOriginal;

      const formaPagamentoFinal = reserva.alterado_financeiro
        ? reserva.forma_pagamento_financeiro?.nome || reserva.forma_pagamento?.nome
        : reserva.forma_pagamento?.nome;

      const condicaoPagamentoFinal = reserva.alterado_financeiro
        ? reserva.condicao_pagamento_financeiro?.nome || reserva.condicao_pagamento?.nome
        : reserva.condicao_pagamento?.nome;

      const financeiroRows = [
        ["Valor", formatCurrency(valorFinal)],
        ["Forma de pagamento", safe(formaPagamentoFinal)],
        ["Condição de pagamento", safe(condicaoPagamentoFinal)],
      ];

      // Renderiza a tabela de dados financeiros
      autoTable(doc, {
        startY: y,
        margin: { left: margin, right: margin },
        theme: "grid",
        body: financeiroRows,
        styles: {
          fontSize: 8.5,
          cellPadding: 2,
          lineColor: borderGray,
          lineWidth: 0.1,
        },
        columnStyles: {
          0: {
            cellWidth: 65,
            fontStyle: "bold",
            fillColor: lightGray,
            textColor: primaryColor,
          },
          1: {
            cellWidth: contentWidth - 65,
            textColor: secondaryColor,
          },
        },
      });

      // Atualiza o Y depois da tabela financeira
      y = doc.lastAutoTable.finalY + 7;

      // // Box do total geral
      // y = checkPageBreak(y, 22);

      // doc.setFillColor(245, 245, 245);
      // doc.roundedRect(margin, y, contentWidth, 14, 2, 2, "F");

      // doc.setFont("helvetica", "bold");
      // doc.setFontSize(11);
      // doc.setTextColor(...primaryColor);
      // doc.text("TOTAL GERAL", margin + 4, y + 9);

      // doc.setFontSize(12);
      // doc.text(formatCurrency(valorFinal), pageWidth - margin - 4, y + 9, {
      //   align: "right",
      // });

      // y += 22;

      // =====================================================
      // PREVISÃO DE PARCELAS
      // =====================================================

      const parcelasReserva = reserva.parcelas || reserva.reserva_parcelas || [];

      if (parcelasReserva.length > 0) {
        y = checkPageBreak(y, 45);
        y = setSectionTitle("PREVISÃO DE PARCELAS", y);

        autoTable(doc, {
          startY: y,
          margin: { left: margin, right: margin },
          head: [["Parcela", "Vencimento", "Status", "Valor"]],
          body: parcelasReserva.map((parcela) => {
            const numeroParcela = parcela.numero_parcela ?? parcela.numeroParcela;
            const totalParcelas = parcela.total_parcelas ?? parcela.totalParcelas;
            const dataVencimento = parcela.data_vencimento ?? parcela.dataVencimento;
            const status = parcela.status || "prevista";
            const valorParcela = Number(parcela.valor || 0);

            return [
              `${numeroParcela}/${totalParcelas}`,
              dataVencimento
                ? moment(dataVencimento).format("DD/MM/YYYY")
                : "Não informado",
              status,
              formatCurrency(valorParcela),
            ];
          }),
          theme: "grid",
          headStyles: {
            fillColor: primaryColor,
            textColor: 255,
            fontSize: 8.5,
          },
          bodyStyles: {
            fontSize: 8,
            cellPadding: 2,
            lineColor: borderGray,
            lineWidth: 0.1,
          },
          columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 45 },
            2: { cellWidth: 45 },
            3: { halign: "right" },
          },
        });

        y = doc.lastAutoTable.finalY + 8;
      }

      y = doc.lastAutoTable.finalY + 7;

      doc.setFillColor(245, 245, 245);
      doc.roundedRect(margin, y, contentWidth, 14, 2, 2, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(...primaryColor);
      doc.text("TOTAL GERAL", margin + 4, y + 9);

      doc.setFontSize(12);
      doc.text(formatCurrency(valorFinal), pageWidth - margin - 4, y + 9, {
        align: "right",
      });

      y += 22;

      // =====================================================
      // OBSERVAÇÃO DA RESERVA
      // =====================================================

      if (reserva.observacao) {
        y = checkPageBreak(y, 35);
        y = setSectionTitle("OBSERVAÇÃO DA RESERVA", y);

        autoTable(doc, {
          startY: y,
          margin: { left: margin, right: margin },
          theme: "grid",
          body: [[reserva.observacao]],
          styles: {
            fontSize: 8.5,
            cellPadding: 3,
            lineColor: borderGray,
            lineWidth: 0.1,
          },
        });

        y = doc.lastAutoTable.finalY + 8;
      }

      // =====================================================
      // ARQUIVOS ANEXADOS
      // =====================================================

      if (reserva.arquivos?.length > 0) {
        y = checkPageBreak(y, 35);
        y = setSectionTitle("ARQUIVOS ANEXADOS", y);

        autoTable(doc, {
          startY: y,
          margin: { left: margin, right: margin },
          head: [["Arquivo", "Observação", "Data de envio"]],
          body: reserva.arquivos.map((arquivo) => [
            safe(arquivo.nome_original, "Arquivo"),
            safe(arquivo.observacao, "-"),
            arquivo.created_at ? moment(arquivo.created_at).format("DD/MM/YYYY") : "Não informado",
          ]),
          theme: "grid",
          headStyles: {
            fillColor: primaryColor,
            textColor: 255,
            fontSize: 8.5,
          },
          bodyStyles: {
            fontSize: 8,
            cellPadding: 2,
            lineColor: borderGray,
            lineWidth: 0.1,
          },
        });

        y = doc.lastAutoTable.finalY + 8;
      }

      addFooter();

      const nomeArquivo = `${tipoDocumento}_${reserva.id}_${sanitizeFileName(expositor.nome)}_${moment().format("YYYYMMDD_HHmm")}.pdf`;

      doc.save(nomeArquivo);
      toast.success("PDF gerado com sucesso!");
    } catch (error) {
      console.error("Erro ao gerar PDF da reserva:", error);
      toast.error("Falha ao gerar PDF da reserva.");
    }
  };

  const toggleModalExpositor = () => setModalExpositor(!modalExpositor);
  const toggleModalCadastroEspaco = () => setModalCadastroEspaco(!modalCadastroEspaco);
  const toggleModalEstande = () => setModalEstande(!modalEstande);
  const toggleModalReprovar = () => setModalReprovar(!modalReprovar);
  const toggleModalDelete = () => setModalDelete(!modalDelete);

  document.title = "Reserva | EVOMAP - Tecnologia que conecta negócios";

  if (loading) return <div className="page-content">Carregando...</div>;
  if (error) return <div className="page-content">Erro: {error}</div>;
  if (!reserva) return <div className="page-content">Nenhuma reserva encontrada</div>;
  if (!reserva.estande) return <div className="page-content">Nenhum dado de reserva encontrado</div>;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      {reserva && (
        <Container fluid>        
          <BreadCrumb 
            title="Detalhes" 
            pageTitle={reserva.gerou_venda ? "Venda" : "Reserva"} 
          />
          
          <Row className="justify-content-center">
            <Col xxl={9}>
              <Card>
                {/* Cabeçalho */}
                <CardHeader className="border-bottom-dashed p-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <Button 
                      color="primary" 
                      onClick={() => navigate(reserva.gerou_venda ? "/vendas" : "/reservas")}
                    >
                      <i className="ri-arrow-left-line align-bottom me-1"></i> Voltar
                    </Button>

                    <div>
                      
                      <Button color="warning" onClick={handleExportarTudoPDF} className="me-2">
                        <i className="ri-file-pdf-line align-bottom me-1"></i> Exportar
                      </Button>

                      <Badge color={reserva.gerou_venda ? "success" : "primary"} className="me-2">
                        {reserva.gerou_venda ? 'VENDA' : 'RESERVA'} #{reserva.id}
                      </Badge>
                      <Badge color={reserva.cancelado ? "danger" : "success"}>
                        {reserva.cancelado ? 'CANCELADA' : 'ATIVA'}
                      </Badge>
                    </div>
                  </div>
                </CardHeader>

                {/* Informações principais */}
                <CardBody>
                  <Row className="mb-3">
                    
                    <Col md={6}>
                      <h5 className="mb-3">
                        <i className="ri-user-line align-bottom me-2"></i> 
                        Informações do Expositor
                      </h5>
                      
                      <div className="d-flex align-items-start mb-3">
                        <div className="flex-grow-1">
                          <h6 className="mb-1">
                            <span className="fw-semibold">Nome:</span> {reserva.expositor.nome}
                          </h6>
                          <p className="mb-1">
                            <span className="fw-semibold">CNPJ/Código:</span> {reserva.expositor.cnpj_codigo_internacional || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">Contato:</span> {reserva.expositor.telefone || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">WhatsApp:</span> {reserva.expositor.whatsapp || 'Não informado'}
                          </p>
                          <p className="mb-1">
                            <span className="fw-semibold">E-mail:</span> {reserva.expositor.email || 'Não informado'}
                          </p>
                        </div>

                        <div>
                          <Button 
                            color="info" 
                            size="sm" 
                            outline
                            onClick={toggleModalExpositor}
                          >
                            <i className="ri-eye-line align-bottom me-1"></i> Ver Completo
                          </Button>
                        </div>
                      </div>
                    </Col>
                    
                    <Col md={6}>
                      <h5 className="mb-3">
                        <i className="ri-calendar-line align-bottom me-2"></i> 
                        Datas
                      </h5>
                      
                      <p className="mb-1">
                        <span className="fw-semibold">Solicitado:</span> {handleValidDate(reserva.created_at)} às {handleValidTime(reserva.created_at)}
                      </p>
                      <p className="mb-1">
                        <span className="fw-semibold">Atualizado:</span> {handleValidDate(reserva.updated_at)} às {handleValidTime(reserva.updated_at)}
                      </p>
                      
                      {reserva.expositor.pendente ? (
                        <Alert color="warning" className="mt-3">
                          <i className="ri-alert-line align-bottom me-2"></i>
                          Expositor aguardando aprovação
                        </Alert>
                      ) : (
                        <div className="mt-3">
                          <span className="fw-semibold">Status Expositor:</span>{' '}
                          {reserva.expositor.aprovado ? (
                            <Badge color="success" className="ms-2">Aprovado</Badge>
                          ) : (
                            <Badge color="danger" className="ms-2">Reprovado</Badge>
                          )}
                        </div>
                      )}
                    </Col>

                    <Col xl={12}>
                      {formatarEndereco(reserva)}
                    </Col>
                  </Row>

                  {/* Aprovação do expositor */}
                  {reserva.expositor.pendente && (
                    <Row className="mb-3">
                      <Col>
                        <div className="d-flex justify-content-end gap-2">
                          <Button 
                            color="danger" 
                            onClick={toggleModalReprovar}
                            disabled={loadingAprovacao}
                          >
                            {loadingAprovacao ? "Processando..." : (
                              <>
                                <i className="mdi mdi-close-circle-outline align-middle me-1"></i>
                                Reprovar Expositor
                              </>
                            )}
                          </Button>
                        
                          <Button 
                            color="success" 
                            disabled={loadingAprovacao}
                            onClick={handleExpositorAprovar}
                          >
                            {loadingAprovacao ? "Processando..." : (
                              <>
                                <i className="mdi mdi-check-bold align-middle me-1"></i>
                                Aprovar Expositor
                              </>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Itens da reserva */}
                  <Row>
                    <div className="d-flex justify-content-between align-items-center ">
                      <Col md={8}>
                        <h5 className="mb-3">
                          <i className="ri-shopping-basket-line align-bottom me-2"></i> 
                          Itens da {reserva.gerou_venda ? 'Venda' : 'Reserva'}
                        </h5>
                      </Col>
                      <div>
                        <Button 
                            color="info" 
                            size="sm" 
                            outline
                            onClick={toggleModalEstande}
                          >
                            <i className="ri-eye-line align-bottom me-1"></i> Ver Espaço
                        </Button>
                    
                        {' '}
                      {permissaoCadastro && (
                        <Button 
                            color="success" 
                            size="sm" 
                            outline
                            onClick={toggleModalCadastroEspaco}
                          >
                            <i className="ri-edit-line align-bottom me-1"></i> Editar Espaço
                        </Button>
                      )}
                      </div>
                    </div>
                    </Row>

                    <Row>
                      <div className="table-responsive">
                        <Table bordered className="mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: "50px" }}>#</th>
                              <th>Item</th>
                              <th>Valor Unitário</th>
                              <th>Quantidade</th>
                              <th className="text-end">Valor Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td>
                                <span className="fw-medium">
                                  {reserva?.estande?.nome || 'Espaço'} -  
                                  {reserva?.estande?.largura || '0'}m x {reserva?.estande?.comprimento || '0'}m
                                </span>
                                <p className="text-muted mb-0">Espaço solicitado {reserva?.estande?.pavilhao?.nome || ''} </p>
                                <p className="text-muted mb-0">{reserva?.estande?.metragem_bonificada > 0 ? `Metragem Bonificada: `+ reserva?.estande?.metragem_bonificada + 'm²' : ''}</p>
                              </td>
                              <td>R$ {(reserva?.estande?.valor || 0).toFixed(2)}</td>
                              <td>{(reserva?.estande?.area || 0)} m²</td>
                              <td className="text-end">R$ {(reserva?.estande?.valor_total || 0).toFixed(2)}</td>
                            </tr>
                            
                            {/* KVA - Verifica se existe KVA vinculado ou se há valor manual salvo */}
                            {(reserva?.estande?.kva != null || reserva?.estande?.kva_manual) && (
                              <tr style={{ borderBottom: "1px solid #ddd" }}>
                                <th scope="row">2</th>
                                <td>
                                  <span className="fw-medium">
                                    KVA {reserva.estande.kva_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                                  </span>
                                  <p className="text-muted mb-0">Item adicional</p>
                                </td>
                                <td style={{ padding: "0.5rem" }}>
                                  {reserva.estande.kva_manual 
                                    ? formatCurrency(reserva.estande.kva_valor_salvo / (reserva.estande.kva_quantidade_salva || 1))
                                    : formatCurrency(reserva.estande.kva?.valor / (reserva.estande.kva?.quantidade || 1))}
                                </td>
                                <td style={{ padding: "0.5rem" }}>
                                  {reserva.estande.kva_manual 
                                    ? (reserva.estande.kva_quantidade_salva || 1)
                                    : (reserva.estande.kva?.cobra_por_metro ? reserva.estande.area : reserva.estande.kva?.quantidade)}
                                </td>
                                <td style={{ padding: "0.5rem", textAlign: "right" }}>
                                  {reserva.estande.kva_manual 
                                    ? formatCurrency(reserva.estande.kva_valor_salvo)
                                    : formatCurrency(reserva.estande.kva?.cobra_por_metro ? (reserva.estande.kva?.valor * reserva.estande.area) : reserva.estande.kva?.valor)}
                                </td>
                              </tr>
                            )}

                            {/* Estacionamento - Verifica se existe Estacionamento ou se há valor manual salvo */}
                            {(reserva?.estande?.estacionamento != null || reserva?.estande?.estacionamento_manual) && (
                              <tr style={{ borderBottom: "1px solid #ddd" }}>
                                <th scope="row">3</th>
                                <td>
                                  <span className="fw-medium">
                                    Estacionamento {reserva.estande.estacionamento_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                                  </span>
                                  <p className="text-muted mb-0">Item adicional</p>
                                </td>
                                <td className="right" style={{ padding: "0.5rem" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? (reserva.estande.estacionamento_valor_salvo <= 0 ? 0 :
                                      formatCurrency(reserva.estande.estacionamento_valor_salvo / (reserva.estande.estacionamento?.quantidade || 1)))
                                    : formatCurrency(reserva.estande.estacionamento?.valor / reserva.estande.estacionamento?.quantidade)}
                                </td>
                                <td className="right" style={{ padding: "0.5rem" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? (reserva.estande.estacionamento_quantidade_salva || 1)
                                    : reserva.estande.estacionamento?.quantidade}
                                </td>
                                <td style={{ padding: "0.5rem", textAlign: "right" }}>
                                  {reserva.estande.estacionamento_manual 
                                    ? formatCurrency(reserva.estande.estacionamento_valor_salvo)
                                    : formatCurrency(reserva.estande.estacionamento?.valor)}
                                </td>
                              </tr>
                            )}

                            {/* Tags / Adicionais - Cruza a configuração da feira com os valores do pivô no estande */}
                            {reserva.estande.tags?.map((tagEstande, index) => {
                              const isManual = tagEstande.manual || tagEstande.manual;
                              const valorUnitario = isManual ? tagEstande.valor_salvo : (tags?.find(t => t.tag_id === tagEstande.id)?.valor || 0);
                              const quantidade = isManual && tagEstande.quantidade_salva > 0 ? tagEstande.quantidade_salva : (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1);
                              
                              const valorTotalTag = isManual ?
                                (tagEstande.quantidade_salva > 0 ? tagEstande.valor_salvo * tagEstande.quantidade_salva : 
                                (tagEstande.valor_salvo * (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1))) : 
                                (valorUnitario * (tagEstande.tag[0].cobra_por_metro ? reserva.estande.area : 1));

                              return (
                                <tr key={`tag-${tagEstande.id}`}>
                                  <th scope="row">{index + 4}</th>
                                  <td>
                                    <span className="fw-medium">
                                      {tagEstande.nome} {isManual && <Badge color="info" className="ms-1">Manual</Badge>}
                                    </span>
                                    <p className="text-muted mb-0">Item adicional</p>
                                  </td>
                                  <td>{formatCurrency(valorUnitario)}</td>
                                  <td>{tagEstande.manual && tagEstande.quantidade_salva > 0 ? quantidade :
                                    tagEstande.tag[0].cobra_por_metro ? `${reserva.estande.area} m²` : quantidade}</td>
                                  <td className="text-end">{formatCurrency(valorTotalTag)}</td>
                                </tr>
                              );
                            })}

                          </tbody>
                         
                          <tfoot className="table-light">
                            {(() => {
                              const subtotalEstande = reserva?.estande?.valor_total || 0;

                              const totalKva = reserva.estande.kva_manual 
                                ? (reserva.estande.kva_valor_salvo || 0) 
                                : (reserva.estande.kva ? (reserva.estande.kva.cobra_por_metro ? reserva.estande.kva.valor * reserva.estande.area : reserva.estande.kva.valor) : 0);

                              const totalEstacionamento = reserva.estande.estacionamento_manual
                                ? (reserva.estande.estacionamento_valor_salvo || 0)
                                : (reserva.estande.estacionamento ? (reserva.estande.estacionamento.valor) : 0);

                              const totalTags = reserva.estande.tags?.reduce((sum, tag) => {
                                
                                const valorUnitario = tag.manual
                                  ? (tag.valor_salvo || tag.valor_salvo)
                                  : (tags?.find(t => t.tag_id === tag.id)?.valor || 0);

                                const qtd = tag.manual && tag.quantidade_salva > 0 ? tag.quantidade_salva :
                                (tag.tag[0].cobra_por_metro ? reserva.estande.area : 1);
                                
                                return sum + (valorUnitario * qtd);
                              }, 0) || 0;


                              const valorTotal = subtotalEstande + totalKva + totalEstacionamento + totalTags;
                              const valorFinanceiro = reserva.valor_total_financeiro;
                              const diferencaFinanceira = valorFinanceiro - valorTotal;
                            
                              return (
                                <>
                                  <tr>
                                    <td colSpan="3" className="border-0"></td>
                                    <td className="border-0 fw-semibold">Subtotal (Itens)</td>
                                    <td className="border-0 text-end fw-semibold">
                                      {formatCurrency(subtotalEstande)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan="3" className="border-0"></td>
                                    <td className="border-0 fw-bold">Total</td>
                                    <td className="border-0 text-end fw-bold">
                                      {formatCurrency(valorTotal)}
                                    </td>
                                  </tr>

                                  {reserva.alterado_financeiro && (
                                  <>
                                    <tr>
                                      <td colSpan="3" className="border-0"></td>
                                      <td className="border-0 fw-bold text-success">
                                        Valor alterado no financeiro
                                      </td>
                                      <td className="border-0 text-end fw-bold text-success">
                                        {formatCurrency(valorFinanceiro)}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td colSpan="3" className="border-0"></td>
                                      <td className="border-0 text-muted">
                                        Diferença
                                      </td>
                                      <td className="border-0 text-end text-muted">
                                        {formatCurrency(diferencaFinanceira)}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                </>
                              );
                            })()}
                          </tfoot>
                        </Table>
                      </div>
                   
                  </Row>

                  {/* Observações */}
                  {reserva.observacao && (
                    <Row className="mt-1">
                        <Col md={12} className="mb-1">
                          <Card className="border border-2 border-warning shadow-sm">
                            <CardHeader className="bg-warning bg-opacity-10">
                              <h5 className="mb-0 text-warning">
                                Observação
                              </h5>
                            </CardHeader>
                            <CardBody>
                              <div className="d-flex align-items-center">
                                <div className="flex-grow-1 ms-3">
                                  <h6 className="mb-1">{reserva.observacao}</h6>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                    </Row>
                  )}

                {/* Informações de pagamento e comercial */}
                <Row className="mt-1">
                  {/* Seção de Pagamento Original */}
                  <Col md={4} className="mb-1">
                    <Card className="h-100 border border-2 border-light shadow-sm">
                      <CardHeader className="bg-light">
                        <h5 className="mb-0">
                          <i className="ri-bank-card-line align-bottom me-2 text-primary"></i>
                          Pagamento
                         
                        </h5>
                         <span className="ms-2">{formatCurrency(reserva.estande.valor_total_geral)}</span>
                      </CardHeader>
                      <CardBody>
                        
                        <div className="d-flex align-items-center mb-2">
                          <div className="flex-shrink-0">
                            <i className="ri-wallet-3-line fs-4 text-muted"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-0">Forma de Pagamento</h6>
                            <p className="text-muted mb-0">
                              {reserva.forma_pagamento.nome || 'Não informado'}
                            </p>
                          </div>
                        </div>
                        
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <i className="ri-calendar-todo-line fs-4 text-muted"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-0">Condição de Pagamento</h6>
                            <p className="text-muted mb-0">
                              {reserva.condicao_pagamento.nome || 'Não informado'}
                            </p>
                          </div>
                        </div>

                      </CardBody>
                    </Card>
                  </Col>

                  {/* Seção de Pagamento Negociado (condicional) */}
                  {reserva.alterado_financeiro && (
                    <Col md={4} className="mb-1">
                      <Card className="h-100 border border-2 border-success shadow-sm">
                        <CardHeader className="bg-success bg-opacity-10">
                          <h5 className="mb-0 text-success">
                            <i className="ri-exchange-dollar-line align-bottom me-2"></i>
                            Pagamento Negociado
                            <span className="badge bg-success ms-2">Atualizado -  {formatCurrency(reserva.valor_total_financeiro)}</span>
                          </h5>
                        </CardHeader>
                        <CardBody>
                          <div className="d-flex align-items-center mb-2">
                            <div className="flex-shrink-0">
                              <i className="ri-wallet-3-line fs-4 text-success"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Forma de Pagamento</h6>
                              <p className="text-success mb-0">
                                {reserva.forma_pagamento_financeiro != null ? reserva.forma_pagamento_financeiro.nome : 'Não informado'}
                              </p>
                            </div>
                          </div>
                          
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <i className="ri-calendar-todo-line fs-4 text-success"></i>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Condição de Pagamento</h6>
                              <p className="text-success mb-0">
                                {reserva.condicao_pagamento_financeiro  != null ? reserva.condicao_pagamento_financeiro.nome : 'Não informado'}
                              </p>
                            </div>
                          </div>

                        </CardBody>
                      </Card>
                    </Col>
                  )}

                  {/* Seção Comercial */}
                  <Col md={4}>
                      <Card className="h-100 border border-2 border-light shadow-sm">
                      <CardHeader className="bg-light">
                        <h5 className="mb-0">
                          <i className="ri-bank-card-line align-bottom me-2 text-primary"></i>
                          Responsável Comercial
                        </h5>
                      </CardHeader>
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <i className="ri-account-circle-line fs-2 text-info"></i>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-1">Vendedor</h6>
                            <p className="text-info mb-0 fw-semibold">
                              {reserva.comercial?.nome || 'Não informado'}
                            </p>
                            {reserva.comercial?.email && (
                              <a 
                                href={`mailto:${reserva.comercial.email}`}
                                className="text-muted small d-block"
                              >
                                <i className="ri-mail-line align-middle me-1"></i>
                                {reserva.comercial.email}
                              </a>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {reserva.parcelas?.length > 0 && (
                  <Row className="mt-3">
                    <Col>
                      <Card className="border border-2 border-light shadow-sm">
                        <CardHeader className="bg-light">
                          <h5 className="mb-0">
                            <i className="ri-calendar-check-line align-bottom me-2 text-primary"></i>
                            Previsão de Parcelas
                          </h5>
                        </CardHeader>

                        <CardBody>
                          <div className="table-responsive">
                            <Table bordered>
                              <thead className="table-light">
                                <tr>
                                  <th>Parcela</th>
                                  <th>Vencimento</th>
                                  <th>Status</th>
                                  <th className="text-end">Valor</th>
                                </tr>
                              </thead>
                              <tbody>
                                {reserva.parcelas.map((parcela) => (
                                  <tr key={parcela.id}>
                                    <td>{parcela.numero_parcela}/{parcela.total_parcelas}</td>
                                    <td>{moment(parcela.data_vencimento).format('DD/MM/YYYY')}</td>
                                    <td>{parcela.status}</td>
                                    <td className="text-end">{formatCurrency(parcela.valor)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                )}

                {reserva.arquivos?.length > 0 && (
                  <Row className="mt-3">
                    <Col>
                      <h5 className="mb-3">
                        <i className="ri-attachment-line align-bottom me-2"></i>
                        Arquivos Anexados
                      </h5>
                      <div className="table-responsive">
                        <Table bordered>
                          <thead className="table-light">
                            <tr>
                              <th>Arquivo</th>
                              <th>Data de Envio</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reserva.arquivos.map((arquivo) => (
                              <tr key={arquivo.id}>
                                <td>
                                  <span className="fw-medium">
                                    {arquivo.nome_original || 'Arquivo'}
                                  </span>
                                  <p className="text-muted mb-0">{arquivo.observacao}</p>
                                </td>
                                <td>{handleValidDate(arquivo.created_at)}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Button 
                                        color="primary" 
                                        size="sm" 
                                        onClick={() => window.open(`${arquivo.url}`, '_blank')}>
                                        <i className="ri-download-line align-bottom me-1"></i> Baixar
                                    </Button>
                                    
                                    <Button 
                                        color="danger" 
                                        size="sm" 
                                        onClick={() => confirmarExclusao(arquivo.id)}>
                                        <i className="ri-delete-bin-fill align-bottom me-1"></i> Excluir
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>)}


                  {/* Etapas do processo */}
                  <Row className="mt-3">
                    <Col>
                      <EtapasProcesso 
                        etapas={reserva.etapas} 
                        reservaId={reserva.id} 
                        feiraId={reserva.feira_id}
                        cancelada={reserva.cancelado}
                        venda={reserva.gerou_venda}
                        renovou={reserva.renovou}
                        ehRenovacao={reserva.feira.renovacao}
                        formaPagamentoId={
                          reserva.alterado_financeiro
                            ? reserva.forma_pagamento_financeiro_id || reserva.forma_pagamento_id
                            : reserva.forma_pagamento_id
                        }

                        condicaoPagamentoId={
                          reserva.alterado_financeiro
                            ? reserva.condicao_pagamento_financeiro_id || reserva.condicao_pagamento_id
                            : reserva.condicao_pagamento_id
                        }

                        valor={
                          reserva.alterado_financeiro
                            ? reserva.valor_total_financeiro
                            : Number(reserva.valor_total ?? reserva.estande.valor_total_geral ?? 0)
                        }

                        parcelas={reserva.parcelas || reserva.reserva_parcelas || []}
                        observacaoFinanceiraAtual={reserva.observacao_financeira || ''}

                        onUpdate={handleUpdateReserva}
                        comerciais={comerciais}
                        comercialId={reserva.comercial_id}
                      />
                      {/* <EtapasProcesso 
                        etapas={reserva.etapas} 
                        reservaId={reserva.id} 
                        feiraId={reserva.feira_id}
                        cancelada={reserva.cancelado}
                        venda={reserva.gerou_venda}
                        renovou={reserva.renovou}
                        formaPagamentoId={reserva.forma_pagamento_id}
                        condicaoPagamentoId={reserva.condicao_pagamento_id}
                        valor={reserva.valor_total ?? reserva.estande.valor_total_geral}
                        onUpdate={handleUpdateReserva}
                        comerciais={comerciais}
                        comercialId={reserva.comercial_id}
                      /> */}
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Button 
                    color="primary" 
                    onClick={() => navigate(reserva.gerou_venda ? "/vendas" : "/reservas")}
                  >
                    <i className="ri-arrow-left-line align-bottom me-1"></i> Voltar
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>

          {/* Modal para reprovar expositor */}
          <Modal isOpen={modalReprovar} toggle={toggleModalReprovar} centered>
            <ModalHeader toggle={toggleModalReprovar}>
              Confirmar Reprovação
            </ModalHeader>
            <ModalBody>
              <p>
                Ao reprovar o expositor, a reserva vinculada será <strong>automaticamente cancelada</strong> e não poderá ser recuperada.
              </p>
              <p>Tem certeza que deseja confirmar a reprovação?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalReprovar}>
                Voltar
              </Button>
              <Button color="danger" onClick={async () => {
                await handleExpositorReprovar();
                toggleModalReprovar();
              }}>
                Confirmar Reprovação
              </Button>
            </ModalFooter>
          </Modal>

          {/* Modal para visualizar dados completos do expositor */}
          <Modal 
            isOpen={modalExpositor} 
            toggle={toggleModalExpositor} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalExpositor}>
              Dados Completos do Expositor
            </ModalHeader>
            <ModalBody>
              <CadastroExpositor 
                id={reserva.expositor_id} 
                feiraId={reserva.feira_id}
                onClose={() => setModalExpositor(false)}
                readOnly // Adicione esta prop se quiser que o modal seja apenas para visualização
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalExpositor}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>

           {/* Modal para visualizar dados completos do estande */}
          <Modal 
            isOpen={modalEstande} 
            toggle={toggleModalEstande} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalEstande}>
              Dados Completos do Espaço
            </ModalHeader>
            <ModalBody>
              <EstandeDetail estande={reserva.estande} tags={tags}></EstandeDetail>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalEstande}>
                Fechar
            </Button>
          </ModalFooter>
          </Modal>

          <Modal isOpen={modalDelete} toggle={toggleModalDelete} centered>
              <div className="modal-header">
                <h5 className="modal-title">Confirmar exclusão</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalDelete(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <p className="fs-15">
                  Tem certeza que deseja excluir?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModalDelete}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => { handleExcluirArquivo(arquivoExcluir)} }>
                  Confirmar
                </button>
              </div>
          </Modal>

          {/* Modal para visualizar dados completos do espaco */}
          <Modal 
            isOpen={modalCadastroEspaco} 
            toggle={toggleModalCadastroEspaco} 
            size="xl"
            scrollable
          >
            <ModalHeader toggle={toggleModalCadastroEspaco}>
              Editar Dados do Espaço (Estande)
            </ModalHeader>
            <ModalBody>
              <CadastroEspaco 
                feiraId={reserva.feira_id} 
                espacoId={reserva.estande_id || reserva.estande?.id} 
                isModal={true}
                onSaveSuccess={handleEspacoSalvo}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleModalCadastroEspaco}>
                Fechar
              </Button>
            </ModalFooter>
          </Modal>

      </Container>

          
    )}
  </div>
  );
};

export default ReservaDetalhes;